import { BASE_BORDER_WIDTH, SPACING_S, SPACING_M, SPACING_XL } from "../../helpers";
var INT_MAX_WIDTH_MENU = 720;
var INT_MAX_HEIGHT_MENU = 800;
var INT_PADDING_LEFT_MENU = parseInt(SPACING_S, 10);
var INT_PADDING_RIGHT_MENU = parseInt(SPACING_M, 10);
var INT_PADDING_TOP_MENU = parseInt(SPACING_S, 10);
export var INT_HEIGHT_FOOTER_MENU = parseInt(SPACING_XL, 10);
export var MAX_WIDTH_MENU = INT_MAX_WIDTH_MENU + "px";
export var DEFAULT_MAX_WIDTH_COLUMN = INT_MAX_WIDTH_MENU -
    INT_PADDING_LEFT_MENU -
    INT_PADDING_RIGHT_MENU + "px";
export var DEFAULT_MAX_HEIGHT_COLUMN = INT_MAX_HEIGHT_MENU -
    INT_PADDING_TOP_MENU -
    INT_HEIGHT_FOOTER_MENU -
    2 * parseInt(BASE_BORDER_WIDTH, 10) + "px";
export var DEFAULT_TEXTS = {
    selectAll: 'Select All',
    clearAll: 'Clear All'
};
export var dataSelectorId = {
    mainControl: 'categorized-choice-main-control',
    selectAll: 'categorized-choice-select-all-control',
    clearAll: 'categorized-choice-clear-all-control',
    partIdCheckbox: 'categorized-choice-checkbox'
};
//# sourceMappingURL=helpers.js.map